import React, { useEffect, useMemo, useState } from 'react'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'
import Typography from '@mui/material/Typography'
import Dialog from '../../../../../dialog/Dialog'
import useElements from '../../../../../../hooks/curriculum/useCurriculumElements'
import { Alert } from '@mui/material'
import { useSelector } from 'react-redux'
import SelectField from '../../../../../FormControl/input/SelectField'

const DialogElement = ({ 
  show, onClose, 
  type, data = {}, 
  setChange,
  baseElement = {}
}) => {
  const getElementOptions = (parent, elementsIds, structure) => {
    const find = structure?.children?.find((el) => el._id === parent._id) || {}
    if (find) {
      if (parent.parent) {
        return getElementOptions(parent.parent, elementsIds, find)
      } else {
        return find.children.map((el) => ({ value: el._id, label: el.name }))
          .filter((el) => !elementsIds.includes(String(el.value)))
      }
    }
    return []
  }
  const elementsStructure = useSelector((state) => state?.curriculum?.elementsStructure || {});
  const optionsElements = useMemo(() => {
    if (data.parentElements) {
      return getElementOptions(data.parentElements, data.elementIds || [], elementsStructure)
    } else {
    const elementsIds = baseElement.elements?.map((el) => String(el.elementStructureId)) || []
    return elementsStructure?.children?.map((el) => ({ value: el._id, label: el.name }))
        .filter((el) => !elementsIds.includes(String(el.value)))
    }
  }, [elementsStructure, baseElement])

  const types = ['create', 'add', 'delete']
  const { 
    errors: errorsData,
    updateElementsElementStructureId
  } = useElements()
  const [form, setInputForm] = useState({})
  const [errors, setInputErrors] = useState(errorsData)
  const [loading, toggleLoading] = useState(false)

  const onChange = (name, value) => {
    setInputForm({ ...form, [name]: value })
    setInputErrors({ ...errors, [name]: null })
  }

  const onSave = async (e) => {
    if (!types.includes(type))  {
      setInputErrors({ message: 'Invalid type' })
      return
    }
    e.preventDefault()
    toggleLoading(true)
    try {
      
      let result = { error: false }
      if (type === 'create') {
        if (!form.elementStructureId) {
          setInputErrors({ elementStructureId: 'Field is required' })
          return
        }
        result = await updateElementsElementStructureId(baseElement._id, 'add', form.elementStructureId , null, form)
      }

      if (type === 'add') {
        if (!form.elementStructureId) {
          setInputErrors({ elementStructureId: 'Field is required' })
          return
        }
        result = await updateElementsElementStructureId(baseElement._id, 'add', form.childrenId , form.parent, form)
      }

      if (type === 'delete') {
        result = await updateElementsElementStructureId(baseElement._id, 'delete', form._id , form.parent, form)
      }

      if (result.error) {
        setInputErrors(result)
      } else {
        onClose()
        setChange((old) => !old)
      }
    } finally {
      toggleLoading(false)
    }
  }

  useEffect(() => {
    setInputErrors(errorsData)
  }, [errorsData])

  useEffect(() => {
    setInputForm(data || {})
  }, [data])

  const Actions = (
    <>
      <ButtonStartIcon
        onClick={onClose}
        color='primary'
        variant='outlined'
        disabled={loading}
        startIcon={["fal","times"]}
      >
        Cancel
      </ButtonStartIcon>
      { types.includes(type) &&
        <ButtonStartIcon
        onClick={onSave}
        color='primary'
        variant='contained'
        disabled={loading}
        loading={loading}
        startIcon={["fal","check"]}
      >
        { type === 'delete' ? 'Confirm' : 'Save'}
      </ButtonStartIcon>
      }
    </>
  );

  return (
    <Dialog
      id={`${type}-element`}
      show={show} 
      title={`${type} element`}
      onClose={onClose}
      actions={Actions}
    >
      { type === 'delete'
        ? <Typography>Are you sure you want to delete the element: <b>{form.name}</b>?</Typography>
        : <div className='flex flex-col gap-4 py-4'>
          <div className='grid grid-cols-4 items-start gap-4'>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Element structure
            </Typography>
            <div className='col-span-3'>
              <SelectField
                id='elementStructureId'
                name='elementStructureId'
                value={form.elementStructureId}
                error={errors?.elementStructureId}
                helperText={errors?.elementStructureId}
                onChange={(e) => onChange("elementStructureId", e.target.value)}
                options={optionsElements}
                fullWidth
              />
            </div>
          </div>
        </div>
      }
      { errors && errors.message && 
        <Alert 
          severity="error"
          onClose={() => setInputErrors({ message: null })}
        >
          {errors.message}
        </Alert> 
      }
    </Dialog>
  )
}

export default DialogElement